/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const sendDipApplicationHeaderParamsSchema = z.object({
  'x-tenant-id': z.string(),
});

/**
 * @description Success response containing the ID of the created application
 */
export const sendDipApplication200Schema = z.object({
  data: z.object({
    applicationId: z.string(),
  }),
  status: z.number(),
});

/**
 * @description Bad Request Error
 */
export const sendDipApplication400Schema = z.object({
  message: z.string().describe('The returned error message'),
  paths: z.array(z.string()).describe('List of details about the bad request error'),
  status: z.number(),
});

/**
 * @description Not Found Error
 */
export const sendDipApplication404Schema = z.object({
  message: z.string().describe('The returned error message'),
  status: z.number(),
});

/**
 * @description Default error response
 */
export const sendDipApplication500Schema = z.object({
  message: z.enum(['Internal Server Error']),
  status: z.number(),
});

export const sendDipApplicationMutationRequestSchema = z.object({
  userId: z.string(),
  customerType: z.enum(['pwl', 'ft', 'gys']),
  agreementReference: z.string(),
});

export const sendDipApplicationMutationResponseSchema = z.lazy(() => sendDipApplication200Schema);
